import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { ARTICLES } from "@/blog/articles";
import SEO, { SITE_ORIGIN } from "@/components/SEO";

export default function Blog() {
  const schemas = [
    {
      "@context": "https://schema.org",
      "@type": "Blog",
      name: "Blog borra-me.com",
      description: "Guías reales sobre privacidad, Ley 21.719, rutificadores y spam de empresas en Chile.",
      inLanguage: "es-CL",
      url: `${SITE_ORIGIN}/blog`,
      publisher: { "@type": "Organization", name: "borra-me.com", url: SITE_ORIGIN },
      blogPost: ARTICLES.map(a => ({
        "@type": "BlogPosting",
        headline: a.title,
        description: a.summary || a.metaDesc,
        datePublished: a.date,
        url: `${SITE_ORIGIN}/blog/${a.slug}`,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: ARTICLES.map((a, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `${SITE_ORIGIN}/blog/${a.slug}`,
        name: a.title,
      })),
    },
  ];

  return (
    <div className="bg-[#F9F9F8] min-h-screen">
      <SEO
        title="Blog borra-me.com — Ley 21.719, rutificadores y spam en Chile"
        description="Guías reales 2026: cómo sacar tu RUT de internet, cómo bloquear llamadas spam, cómo usar No Molestar SERNAC, cómo detener el marketing de bancos y retail bajo la Ley 21.719."
        canonical="/blog"
        keywords="blog privacidad chile, ley 21.719 blog, sacar rut de internet, bloquear llamadas spam"
        schemas={schemas}
      />
      <section className="border-b border-gray-200 bg-white">
        <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 py-16 lg:py-24">
          <div className="eyebrow mb-4 text-[#DC2626]">Blog · borra-me.com</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 leading-[1.05]" data-testid="blog-h1">
            Guías reales sobre tu privacidad,<br/>
            <span className="text-gray-500">la Ley 21.719, rutificadores y spam de empresas.</span>
          </h1>
          <p className="mt-6 text-lg text-gray-700 max-w-3xl leading-relaxed">
            Cómo sacar tu RUT de internet, cómo cortar el spam telefónico desde la fuente, cómo detener el marketing de bancos, telcos y retail, qué te da la nueva Ley 21.719 y cómo usar la APDP cuando un responsable no cumple. Sin lenguaje jurídico.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid lg:grid-cols-2 gap-px bg-gray-200 border border-gray-200">
          {ARTICLES.map(a => (
            <Link key={a.slug} to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`}
              className="bg-white p-8 hover:bg-[#F9F9F8] transition-colors group flex flex-col">
              <div className="flex items-center gap-3 text-xs font-mono uppercase tracking-[0.18em] text-gray-500 mb-4">
                <span>{new Date(a.date).toLocaleDateString("es-CL", { day: "2-digit", month: "short", year: "numeric" })}</span>
                <span className="text-gray-300">·</span>
                <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" />{a.readMin} min lectura</span>
              </div>
              <h2 className="font-display text-xl lg:text-2xl font-bold text-gray-900 leading-snug group-hover:text-[#0B2447]">
                {a.title}
              </h2>
              <p className="mt-4 text-sm text-gray-700 leading-relaxed flex-1">{a.excerpt}</p>
              <div className="mt-6 inline-flex items-center gap-2 text-[#0B2447] font-semibold text-sm group-hover:gap-3 transition-all">
                Leer artículo <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
